import bus from '@/bus.js';
import { key } from "@/env";
import { websocket } from '@/env';



class socket {

    constructor(options) {
        
    }

    init({ callback }) {
        if (this.socketStart) {
            console.log('webSocket已经启动了');
        } else {
            const token = window.localStorage.getItem(key.token);
            this.socketStart = false;
            this.websock = new WebSocket(websocket.url + "?token=" + token);
            this.onError();
            this.onClose();
            this.onMessage();
            this.websock.onopen = (res) => {
                this.socketStart = true;
                callback && callback(true);
                console.log('WebSocket连接已打开！');
            };
            let _self = this;
            setTimeout(() => {
                _self.getHeartbeat();
            }, 5000);
        }
    }
    
    //Socket给服务器发送消息
    send(data, callback) {
        console.log('主动推送消息', data);
        try {
            this.websock.send(JSON.stringify(data));
            callback && callback(true);
        } catch (error) {
            callback && callback(false);
        }
    }
    
    //Socket接收服务器发送过来的消息
    onMessage() {
        let _self = this;
        this.websock.onmessage = function (res) {
            _self.handleMessage(res);
        };
    }
    
    //关闭Socket
    closeSocket() {
        this.websock = null;
        this.socketStart = false;
    }
    
    //监听Socket关闭
    onClose() {
        let _self = this;
        this.websock.onclose = function (res) {
            console.log('WebSocket 已关闭！');
            _self.socketStart = false;
            // setTimeout(function() {
            // 	_self.init();
            // }, 3000);
        };
    }
    
    //监听Socket错误
    onError() {
        let _self = this;
        _self.websock.onerror = function (res) {
            _self.socketStart = false;
            console.log('WebSocket连接打开失败，请检查！');
        };
    }
    
    //心跳
    getHeartbeat() {
        let _self = this;
        if (!this.socketStart) {
            console.log('webSocket尚未启动');
            return;
        }
        this.send({
            scene: 'heart.pack',
        }, (val) => {
            setTimeout(() => {
                if (val) {
                    _self.getHeartbeat();
                } else {
                    _self.init();
                }
            }, 10000);
        });
    }


    handleMessage(res) {
        let data = res.data;
        console.log('收到服务器内容：', data);
        switch (res.data) {
            case 'User Not Found':
                break;
            default:
                data = JSON.parse(data);
                if (data) {
                    switch (data.scene) {
                        case 'notice': // 公告
                            bus.$emit('notice', data);
                            break;
                        case 'robot.speech':
                            bus.$emit('robot.speech', data);
                            break;
                        case 'admin.alone_chat':
                            bus.$emit('socket.' + data.room, data);
                            break;
                        
                    }
                }
                break;
        }
    }
};
const mySocket = new socket();
export default mySocket;



// WEBPACK FOOTER //
// ./src/socket/index.js